/*
*   使用 tool  各种工具
*/

let tool = {
    numToDate: function (value) {
        if(value && value !=null){
            // value = value.length === 13 ? value : value * 1000;
            return new Date(value);
        }
        return value;
    },
    dateToNum: function (value) {
        if(value && value !== null){
            return new Date(value).getTime();
        }
        return value;
    },
    toFixed1: function (value, num){  // NumberObject.toFixed(num)  new Number(999).toFixed (4)
        if(typeof value ==='number' && value !== null){
            return value.toFixed(num);
        }
        return value;
    },
    // 深拷贝
    deepCopy: function (obj) {
        let newobj;
        if(Object.prototype.toString.call(obj) === "[object Array]" && window.JSON){
            newobj = JSON.parse(JSON.stringify(obj)); //还原
        } else {
            newobj = {};
            for(var key in obj){
                if (obj.hasOwnProperty(key)) {
                    newobj[key] = typeof obj[key] === 'object' ?
                        tool.deepCopy(obj[key]) : obj[key];
                }
            }
        }
        return newobj;
    },
    /*
	*	DateSplit:指定日期分隔符，例如2017-7-4
	*	DateToClock:指定日期和时间中间的分隔符
	*	ClockSplit:指定时间分隔符，例如11:02
	*/
    transformTime:function(value, secFlag,DateSplit,DateToClock,ClockSplit){
        if(value=== null || !value || value === ''){
            return value;
        }
        // 默认分隔符
        this.value = value;
        this.DateSplit = DateSplit || '-';
        this.DateToClock = DateToClock || ' ';
        this.ClockSplit = ClockSplit || ':';

        return this.setTime(secFlag);
    },
    /*
    *	secFlag:是否需要秒
    */
    setTime:function(secFlag){
        switch(secFlag) {
            case 'yyyy-mm-dd':
                return this.getYear() + this.DateSplit + this.getMonth() + this.DateSplit + this.getDate();
                break;
            case 'yyyy':
                return this.getYear() ;
                break;
            case 'hh:mm:ss':
                return this.getHours() + this.ClockSplit + this.getMinutes()+ this.getSeconds();
            default:
                return (this.getYear() + this.DateSplit + this.getMonth() + this.DateSplit + this.getDate() +  this.DateToClock + this.getHours() + this.ClockSplit + this.getMinutes()+(secFlag ? this.ClockSplit + this.getSeconds() : '' ));
        }
    },

    // 获取时间
    getTime:function(){
        if(this.value && this.value!=null){
            return new Date(this.value);
        } else {
            return this.value;
        }
        return new Date();

    },
    getYear : function(){
        return this.getTime().getFullYear();
    },
    getMonth : function(){
        return (this.getTime().getMonth()+1);
    },
    getDate : function(){
        return this.getTime().getDate();
    },
    getDay : function(){
        return (this.getTime().getDay()+1)
    },
    getHours : function(){
        return this.getTime().getHours();
    },
    getMinutes : function(){
        return this.getTime().getMinutes();
    },
    getSeconds : function(){
        return this.getTime().getSeconds();
    }
};

export default  tool;


// WEBPACK FOOTER //
// ./src/assets/js/common/tool.js